
// // import { useEffect, useMemo, useState, useCallback } from "react";

// // /* ─── image mapping ─── */
// // const eventImages = {
// //   "Fintech Festival": "/images/event-fintech.jpg",
// //   "Investment Roadshow": "/images/event-roadshow.jpg",
// //   "Agriculture Conclave": "/images/event-agriculture.jpg",
// //   "Tax Conference": "/images/event-fintech.jpg",
// //   "Chemical Conclave": "/images/event-chemical.jpg",
// //   "Bond Market Summit": "/images/event-fintech.jpg",
// //   "Education Meet": "/images/event-education.jpg",
// //   "Manufacturing Conference": "/images/event-manufacturing.jpg",
// //   "Mobility Summit": "/images/event-manufacturing.jpg",
// //   "IP Awards": "/images/event-tech-ai.jpg",
// //   "AgriTech Forum": "/images/event-agriculture.jpg",
// //   "Manufacturing Conclave": "/images/event-manufacturing.jpg",
// //   "Family Business Conclave": "/images/event-roadshow.jpg",
// //   "Mining Conclave": "/images/event-mining.jpg",
// //   "Energy Summit": "/images/event-energy.jpg",
// //   "Governance Conclave": "/images/event-roadshow.jpg",
// //   "Pharma Summit": "/images/event-healthcare.jpg",
// //   "MSME Summit": "/images/event-roadshow.jpg",
// //   "Health Meet": "/images/event-healthcare.jpg",
// //   "Education Summit": "/images/event-education.jpg",
// //   "Technology Summit": "/images/event-tech-ai.jpg",
// //   "Business Summit": "/images/event-roadshow.jpg",
// //   "National Seminar": "/images/event-roadshow.jpg",
// // };

// // const fallbackImages = [
// //   "/images/event-fintech.jpg",
// //   "/images/event-agriculture.jpg",
// //   "/images/event-chemical.jpg",
// //   "/images/event-education.jpg",
// //   "/images/event-healthcare.jpg",
// //   "/images/event-manufacturing.jpg",
// //   "/images/event-energy.jpg",
// //   "/images/event-tech-ai.jpg",
// //   "/images/event-mining.jpg",
// //   "/images/event-roadshow.jpg",
// // ];

// // /* ─── event data ─── */
// // const forthcomingEvents = [
// //   { title: "3rd India International Fintech Festival", date: "07 Aug, 2026", category: "Fintech Festival", accent: "Festival", type: "Summit" },
// //   { title: "Invest in Odisha Roadshow", date: "19 Aug, 2026", category: "Investment Roadshow", accent: "Business", type: "Roadshow" },
// //   { title: "Farm to Foreign Conclave", date: "19 Aug, 2026", category: "Agriculture Conclave", accent: "Export", type: "Conclave" },
// //   { title: "23rd International Tax Conference", date: "20 Aug, 2026", category: "Tax Conference", accent: "Finance", type: "Conference" },
// //   { title: "2nd edition of Gujarat Chemical & Petrochemical Conclave", date: "20 Aug, 2026", category: "Chemical Conclave", accent: "Industry", type: "Conclave" },
// //   { title: "ASSOCHAM IX National Summit & Awards on Corporate Bond Market", date: "21 Aug, 2026", category: "Bond Market Summit", accent: "Awards", type: "Awards" },
// //   { title: "10th Edition of The Edu Meet 2026 & Excellence Awards", date: "25 Aug, 2026", category: "Education Meet", accent: "Recognition", type: "Awards" },
// //   { title: "National Conference on Aerospace & Defence Manufacturing", date: "09 Sep–12 Sep, 2026", category: "Manufacturing Conference", accent: "Defence", type: "Conference" },
// //   { title: "MobilityNext 2047 – Driving Innovation, Partnerships and Policy for Electric Mobility", date: "30 Oct, 2026", category: "Mobility Summit", accent: "Innovation", type: "Summit" },
// //   { title: "5th IP Excellence Awards 2026", date: "31 Oct, 2026", category: "IP Awards", accent: "Excellence", type: "Awards" },
// //   { title: "4th AgriTech: Smart Farming | Sustainable Future", date: "31 Dec, 2026", category: "AgriTech Forum", accent: "Sustainability", type: "Forum" },
// //   { title: "3rd Edition of Manufacturing Conclave & Excellence Awards 2026", date: "31 Dec, 2026", category: "Manufacturing Conclave", accent: "Leadership", type: "Awards" },
// // ];

// // const pastEvents = [
// //   { title: "1st Edition of Growth Driven Family Business Conclave & Excellence Awards 2026", date: "24 Jun, 2026", category: "Family Business Conclave", accent: "Growth", type: "Awards" },
// //   { title: "4th Edition of Minerals and Mining Conclave 2026", date: "19 Jun, 2026", category: "Mining Conclave", accent: "Resources", type: "Conclave" },
// //   { title: "Telangana Clean Energy Summit 2026", date: "18 Jun, 2026", category: "Energy Summit", accent: "Clean Energy", type: "Summit" },
// //   { title: "ASSOCHAM National Conclave on Future of Financial Governance", date: "17 Jun, 2026", category: "Governance Conclave", accent: "Policy", type: "Conclave" },
// //   { title: "ASSOCHAM 2nd Pharma Summit & Awards 2026", date: "11 Jun, 2026", category: "Pharma Summit", accent: "Healthcare", type: "Awards" },
// //   { title: "2nd Edition MahaMSMErashtra Empowerment Summit", date: "10 Jun, 2026", category: "MSME Summit", accent: "Empowerment", type: "Summit" },
// //   { title: "6th edition of The Health Meet & Excellence Awards 2026", date: "29 May, 2026", category: "Health Meet", accent: "Awards", type: "Awards" },
// //   { title: "ASSOCHAM Rajasthan Education Summit 2026: Empowering Rajasthan through AI-Driven Education & Vision 2030", date: "29 May, 2026", category: "Education Summit", accent: "AI", type: "Summit" },
// //   { title: "10th ASSOCHAM Smart Datacenters, Cloud & AI Summit 2026", date: "28 May, 2026", category: "Technology Summit", accent: "Cloud & AI", type: "Summit" },
// //   { title: "India Speciality Chemicals Conclave – Speciality Chemicals for Economic Growth and Job Creation", date: "21 May, 2026", category: "Chemical Conclave", accent: "Economic Growth", type: "Conclave" },
// //   { title: "India Business Reform Summit 2026", date: "19 May, 2026", category: "Business Summit", accent: "Reforms", type: "Summit" },
// //   { title: "ASSOCHAM's National Seminar on New Labour Codes", date: "13 May, 2026", category: "National Seminar", accent: "Labour Codes", type: "Seminar" },
// // ];

// // const allEvents = [
// //   ...forthcomingEvents.map((e) => ({ ...e, status: "forthcoming" })),
// //   ...pastEvents.map((e) => ({ ...e, status: "past" })),
// // ];

// // function getEventImage(event, index) {
// //   const mapped = eventImages[event.category];
// //   if (mapped) return mapped;
// //   return fallbackImages[index % fallbackImages.length];
// // }

// // /* ─── Animated counter ─── */
// // function AnimatedNumber({ value, duration = 700 }) {
// //   const [display, setDisplay] = useState(0);
// //   useEffect(() => {
// //     let raf;
// //     const start = performance.now();
// //     const tick = (now) => {
// //       const progress = Math.min((now - start) / duration, 1);
// //       const eased = 1 - Math.pow(1 - progress, 3);
// //       setDisplay(Math.round(value * eased));
// //       if (progress < 1) raf = requestAnimationFrame(tick);
// //     };
// //     raf = requestAnimationFrame(tick);
// //     return () => cancelAnimationFrame(raf);
// //   }, [value, duration]);
// //   return <span>{display}</span>;
// // }

// // /* ─── Event image thumbnail ─── */
// // function EventImageCard({ event, active, index }) {
// //   const parts = event.date.split(" ");
// //   const dayPart = parts[0];
// //   const restPart = parts.slice(1).join(" ");
// //   const [monthPart] = restPart.split(",");
// //   const yearMatch = event.date.match(/(20\d{2})/);
// //   const year = yearMatch ? yearMatch[1] : "2026";
// //   const imageUrl = getEventImage(event, index);

// //   return (
// //     <div className="relative mx-auto flex h-[130px] w-[150px] shrink-0 overflow-hidden rounded-2xl shadow-sm transition-all duration-400 group-hover:-translate-y-0.5 group-hover:shadow-md sm:mx-0">
// //       <img
// //         src={imageUrl}
// //         alt={event.title}
// //         className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
// //         loading="lazy"
// //       />
// //       <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/25 to-transparent" />

// //       {/* Type badge */}
// //       <div className="absolute right-2 top-2 z-10">
// //         <span className="inline-block rounded-md bg-black/45 px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wider text-white/90 backdrop-blur-sm">
// //           {event.type}
// //         </span>
// //       </div>

// //       {/* Date overlay */}
// //       <div className="absolute bottom-0 left-0 right-0 z-10 px-3 py-2.5">
// //         <div className="flex items-end justify-between">
// //           <div>
// //             <div className="text-2xl font-bold leading-none text-white">{dayPart}</div>
// //             <div className="mt-0.5 text-[10px] font-semibold uppercase tracking-widest text-amber-300">
// //               {monthPart}
// //             </div>
// //           </div>
// //           <div
// //             className={`rounded-md px-1.5 py-0.5 text-[10px] font-semibold text-white ${
// //               active ? "bg-red-700" : "bg-gray-600"
// //             }`}
// //           >
// //             {year}
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // }

// // /* ─── Event card ─── */
// // function EventCard({ event, active, index }) {
// //   const delay = `${Math.min(index * 60, 500)}ms`;
// //   return (
// //     <article
// //       style={{ animationDelay: delay }}
// //       className="ev-fade-up group relative overflow-hidden rounded-2xl border border-gray-200 bg-white p-4 shadow-sm transition-all duration-300 hover:border-gray-300 hover:shadow-md sm:p-5"
// //     >
// //       <div className="relative flex flex-col gap-4 sm:flex-row sm:items-start">
// //         <EventImageCard event={event} active={active} index={index} />

// //         <div className="min-w-0 flex-1 space-y-2.5">
// //           {/* Tags */}
// //           <div className="flex flex-wrap items-center gap-1.5">
// //             <span className="inline-flex rounded-full bg-red-50 px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wide text-red-700">
// //               {event.category}
// //             </span>
// //             <span className="inline-flex rounded-full border border-amber-200 bg-amber-50 px-2.5 py-0.5 text-[11px] font-medium text-amber-700">
// //               {event.accent}
// //             </span>
// //             {active ? (
// //               <span className="inline-flex items-center gap-1 rounded-full bg-emerald-50 px-2.5 py-0.5 text-[11px] font-semibold text-emerald-700">
// //                 <span className="relative flex h-1.5 w-1.5">
// //                   <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-500 opacity-75" />
// //                   <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-emerald-500" />
// //                 </span>
// //                 Upcoming
// //               </span>
// //             ) : (
// //               <span className="inline-flex rounded-full bg-gray-100 px-2.5 py-0.5 text-[11px] font-medium text-gray-500">
// //                 Archived
// //               </span>
// //             )}
// //           </div>

// //           {/* Title */}
// //           <h3 className="text-[15px] font-semibold leading-snug text-gray-900 transition-colors duration-300 group-hover:text-red-700 sm:text-base">
// //             {event.title}
// //           </h3>

// //           {/* Date + CTA */}
// //           <div className="flex flex-col gap-2.5 sm:flex-row sm:items-center sm:justify-between">
// //             <div className="flex items-center gap-2 text-sm text-gray-500">
// //               <span className="inline-flex h-6 w-6 items-center justify-center rounded-full bg-red-700 text-white">
// //                 <svg viewBox="0 0 24 24" className="h-3 w-3 fill-none" stroke="currentColor" strokeWidth="2.2">
// //                   <path d="M8 2v4" />
// //                   <path d="M16 2v4" />
// //                   <rect x="3" y="5" width="18" height="16" rx="2" />
// //                   <path d="M3 10h18" />
// //                 </svg>
// //               </span>
// //               <span className="font-medium">{event.date}</span>
// //             </div>

// //             <button
// //               type="button"
// //               className="inline-flex w-fit items-center gap-1.5 rounded-lg bg-red-700 px-3.5 py-1.5 text-[13px] font-semibold text-white shadow-sm transition-all duration-200 hover:bg-red-800 active:scale-[0.98]"
// //             >
// //               {active ? "Register Interest" : "View Highlights"}
// //               <svg viewBox="0 0 24 24" className="h-3.5 w-3.5 transition-transform duration-200 group-hover:translate-x-0.5" fill="none" stroke="currentColor" strokeWidth="2.2">
// //                 <path d="M5 12h14" />
// //                 <path d="m13 5 7 7-7 7" />
// //               </svg>
// //             </button>
// //           </div>
// //         </div>
// //       </div>
// //     </article>
// //   );
// // }

// // /* ─── Select field ─── */
// // function SelectField({ label, value, options, onChange, placeholder = "Select" }) {
// //   return (
// //     <div className="space-y-1">
// //       <label className="text-xs font-medium text-gray-600">{label}</label>
// //       <div className="relative">
// //         <select
// //           value={value}
// //           onChange={(e) => onChange(e.target.value)}
// //           className="w-full appearance-none rounded-lg border border-gray-200 bg-white py-2 pl-3 pr-9 text-sm text-gray-700 transition duration-200 hover:border-gray-300 focus:border-red-500 focus:outline-none focus:ring-2 focus:ring-red-100"
// //         >
// //           <option value="">{placeholder}</option>
// //           {options.map((opt) => (
// //             <option key={opt} value={opt}>
// //               {opt}
// //             </option>
// //           ))}
// //         </select>
// //         <svg viewBox="0 0 24 24" className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" fill="none" stroke="currentColor" strokeWidth="2">
// //           <path d="m6 9 6 6 6-6" />
// //         </svg>
// //       </div>
// //     </div>
// //   );
// // }

// // /* ─── Breadcrumb ─── */
// // function Breadcrumb() {
// //   return (
// //     <nav aria-label="Breadcrumb" className="ev-fade-in absolute left-4 top-4 z-20 sm:left-8 sm:top-5">
// //       <ol className="flex items-center gap-2 rounded-full border border-white/20 bg-white/15 px-4 py-1.5 text-xs font-medium text-white/90 backdrop-blur-md">
// //         <li>
// //           <a href="#top" className="inline-flex items-center gap-1.5 transition-colors hover:text-white">
// //             <svg viewBox="0 0 24 24" className="h-3.5 w-3.5" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
// //               <path d="M3 10.5 12 3l9 7.5" />
// //               <path d="M5 10v10h14V10" />
// //               <path d="M9 20v-6h6v6" />
// //             </svg>
// //             Home
// //           </a>
// //         </li>
// //         <li className="text-white/40">›</li>
// //         <li className="font-semibold text-white">Events</li>
// //       </ol>
// //     </nav>
// //   );
// // }

// // /* ─── Filter icon SVGs ─── */
// // function FilterIcon({ className = "h-5 w-5" }) {
// //   return (
// //     <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
// //       <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
// //     </svg>
// //   );
// // }

// // function CloseIcon({ className = "h-5 w-5" }) {
// //   return (
// //     <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
// //       <line x1="18" y1="6" x2="6" y2="18" />
// //       <line x1="6" y1="6" x2="18" y2="18" />
// //     </svg>
// //   );
// // }

// // /* ─── Sidebar content (shared between mobile & desktop) ─── */
// // function SidebarContent({
// //   draftTab,
// //   draftKeywords,
// //   draftEventType,
// //   draftEventDate,
// //   draftSubject,
// //   draftOnlineType,
// //   draftRegions,
// //   setDraftKeywords,
// //   setDraftEventType,
// //   setDraftEventDate,
// //   setDraftSubject,
// //   setDraftOnlineType,
// //   setDraftRegions,
// //   handleSidebarStatus,
// //   handleSearch,
// //   handleClear,
// //   eventTypes,
// //   subjects,
// //   onlineTypes,
// //   regions,
// // }) {
// //   return (
// //     <>
// //       <div className="space-y-3">
// //         {/* Keywords */}
// //         <div className="space-y-1">
// //           <label className="text-xs font-medium text-gray-600">Keywords</label>
// //           <div className="relative">
// //             <svg viewBox="0 0 24 24" className="pointer-events-none absolute left-3 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-gray-400" fill="none" stroke="currentColor" strokeWidth="2">
// //               <circle cx="11" cy="11" r="7" />
// //               <path d="m20 20-3.5-3.5" />
// //             </svg>
// //             <input
// //               type="text"
// //               value={draftKeywords}
// //               onChange={(e) => setDraftKeywords(e.target.value)}
// //               onKeyDown={(e) => e.key === "Enter" && handleSearch()}
// //               placeholder="Search by title, sector…"
// //               className="w-full rounded-lg border border-gray-200 bg-white py-2 pl-9 pr-3 text-sm text-gray-700 transition duration-200 placeholder:text-gray-400 hover:border-gray-300 focus:border-red-500 focus:outline-none focus:ring-2 focus:ring-red-100"
// //             />
// //           </div>
// //         </div>

// //         {/* Status toggle */}
// //         <div className="space-y-1">
// //           <label className="text-xs font-medium text-gray-600">Status</label>
// //           <div className="flex gap-1 rounded-lg border border-gray-200 bg-gray-50 p-1">
// //             <button
// //               type="button"
// //               onClick={() => handleSidebarStatus("forthcoming")}
// //               className={`flex-1 rounded-md px-3 py-1.5 text-sm font-medium transition duration-200 ${
// //                 draftTab === "forthcoming"
// //                   ? "bg-red-700 text-white shadow-sm"
// //                   : "text-gray-500 hover:text-gray-700"
// //               }`}
// //             >
// //               Forthcoming
// //             </button>
// //             <button
// //               type="button"
// //               onClick={() => handleSidebarStatus("past")}
// //               className={`flex-1 rounded-md px-3 py-1.5 text-sm font-medium transition duration-200 ${
// //                 draftTab === "past"
// //                   ? "bg-red-700 text-white shadow-sm"
// //                   : "text-gray-500 hover:text-gray-700"
// //               }`}
// //             >
// //               Past
// //             </button>
// //           </div>
// //         </div>

// //         <SelectField label="Event type" value={draftEventType} options={eventTypes} onChange={setDraftEventType} placeholder="All types" />
// //         <SelectField label="Date range" value={draftEventDate} options={["This Week", "This Month", "Next 3 Months", "This Quarter", "This Year"]} onChange={setDraftEventDate} placeholder="Any date" />
// //         <SelectField label="Subject" value={draftSubject} options={subjects} onChange={setDraftSubject} placeholder="All subjects" />
// //         <SelectField label="Format" value={draftOnlineType} options={onlineTypes} onChange={setDraftOnlineType} placeholder="All formats" />
// //         <SelectField label="Region" value={draftRegions} options={regions} onChange={setDraftRegions} placeholder="All regions" />
// //       </div>

// //       {/* Action buttons */}
// //       <div className="mt-5 flex gap-2">
// //         <button
// //           type="button"
// //           onClick={handleSearch}
// //           className="flex flex-1 items-center justify-center gap-1.5 rounded-lg bg-red-700 px-4 py-2 text-sm font-semibold text-white transition duration-200 hover:bg-red-800"
// //         >
// //           <svg viewBox="0 0 24 24" className="h-3.5 w-3.5 fill-none" stroke="currentColor" strokeWidth="2.2">
// //             <circle cx="11" cy="11" r="7" />
// //             <path d="m20 20-3.5-3.5" />
// //           </svg>
// //           Search
// //         </button>
// //         <button
// //           type="button"
// //           onClick={handleClear}
// //           className="flex flex-1 items-center justify-center gap-1.5 rounded-lg border border-gray-200 bg-white px-4 py-2 text-sm font-medium text-gray-600 transition duration-200 hover:bg-gray-50"
// //         >
// //           Clear
// //         </button>
// //       </div>

// //       {/* Help box */}
// //       <div className="mt-5 rounded-xl border border-amber-200 bg-amber-50 p-3.5">
// //         <p className="text-[10px] font-semibold uppercase tracking-[0.15em] text-amber-700">Need assistance?</p>
// //         <p className="mt-1.5 text-xs leading-relaxed text-gray-600">
// //           Looking to partner, sponsor, or nominate for an awards category? Connect with the events desk.
// //         </p>
// //         <button type="button" className="mt-2.5 inline-flex items-center gap-1 text-xs font-semibold text-red-700 transition hover:gap-2">
// //           Contact Team
// //           <svg viewBox="0 0 24 24" className="h-3 w-3 fill-none" stroke="currentColor" strokeWidth="2.2">
// //             <path d="M5 12h14" />
// //             <path d="m13 5 7 7-7 7" />
// //           </svg>
// //         </button>
// //       </div>
// //     </>
// //   );
// // }

// // /* ─── Main page ─── */
// // export default function EventPage() {
// //   const [activeTab, setActiveTab] = useState("forthcoming");
// //   const [draftTab, setDraftTab] = useState("forthcoming");
// //   const [draftKeywords, setDraftKeywords] = useState("");
// //   const [draftEventType, setDraftEventType] = useState("");
// //   const [draftEventDate, setDraftEventDate] = useState("");
// //   const [draftSubject, setDraftSubject] = useState("");
// //   const [draftOnlineType, setDraftOnlineType] = useState("");
// //   const [draftRegions, setDraftRegions] = useState("");
// //   const [filterOpen, setFilterOpen] = useState(false);

// //   const [applied, setApplied] = useState({
// //     tab: "forthcoming",
// //     keywords: "",
// //     eventType: "",
// //     eventDate: "",
// //     subject: "",
// //     onlineType: "",
// //     regions: "",
// //   });

// //   const [animKey, setAnimKey] = useState(0);

// //   const eventTypes = useMemo(() => Array.from(new Set(allEvents.map((e) => e.type))), []);
// //   const subjects = useMemo(() => Array.from(new Set(allEvents.map((e) => e.accent))), []);
// //   const onlineTypes = ["In-Person", "Virtual", "Hybrid"];
// //   const regions = ["Delhi NCR", "Mumbai", "Odisha", "Gujarat", "Telangana", "Rajasthan", "Pan-India"];

// //   /* Lock body scroll when filter drawer is open */
// //   useEffect(() => {
// //     if (filterOpen) {
// //       document.body.style.overflow = "hidden";
// //     } else {
// //       document.body.style.overflow = "";
// //     }
// //     return () => {
// //       document.body.style.overflow = "";
// //     };
// //   }, [filterOpen]);

// //   const applyFilters = useCallback((next) => {
// //     setApplied(next);
// //     setActiveTab(next.tab);
// //     setDraftTab(next.tab);
// //     setAnimKey((k) => k + 1);
// //   }, []);

// //   const handleTab = (tab) => {
// //     setActiveTab(tab);
// //     setDraftTab(tab);
// //     setApplied((prev) => ({ ...prev, tab }));
// //     setAnimKey((k) => k + 1);
// //   };

// //   const handleSidebarStatus = (tab) => {
// //     setDraftTab(tab);
// //     setActiveTab(tab);
// //     setApplied((prev) => ({
// //       ...prev,
// //       tab,
// //       keywords: draftKeywords.trim(),
// //       eventType: draftEventType,
// //       eventDate: draftEventDate,
// //       subject: draftSubject,
// //       onlineType: draftOnlineType,
// //       regions: draftRegions,
// //     }));
// //     setAnimKey((k) => k + 1);
// //   };

// //   const handleSearch = useCallback(() => {
// //     applyFilters({
// //       tab: draftTab,
// //       keywords: draftKeywords.trim(),
// //       eventType: draftEventType,
// //       eventDate: draftEventDate,
// //       subject: draftSubject,
// //       onlineType: draftOnlineType,
// //       regions: draftRegions,
// //     });
// //     setFilterOpen(false);
// //   }, [draftTab, draftKeywords, draftEventType, draftEventDate, draftSubject, draftOnlineType, draftRegions, applyFilters]);

// //   const handleClear = useCallback(() => {
// //     setDraftKeywords("");
// //     setDraftEventType("");
// //     setDraftEventDate("");
// //     setDraftSubject("");
// //     setDraftOnlineType("");
// //     setDraftRegions("");
// //     setDraftTab("forthcoming");
// //     applyFilters({
// //       tab: "forthcoming",
// //       keywords: "",
// //       eventType: "",
// //       eventDate: "",
// //       subject: "",
// //       onlineType: "",
// //       regions: "",
// //     });
// //     setFilterOpen(false);
// //   }, [applyFilters]);

// //   const activeEvents = useMemo(() => {
// //     const base = applied.tab === "forthcoming" ? forthcomingEvents : pastEvents;
// //     const kw = applied.keywords.toLowerCase();
// //     return base.filter((e) => {
// //       if (applied.eventType && e.type !== applied.eventType) return false;
// //       if (applied.subject && e.accent !== applied.subject) return false;
// //       if (kw) {
// //         const hay = `${e.title} ${e.category} ${e.accent}`.toLowerCase();
// //         if (!hay.includes(kw)) return false;
// //       }
// //       return true;
// //     });
// //   }, [applied]);

// //   const totalCount = activeEvents.length;
// //   const statusLabel = applied.tab === "forthcoming" ? "Upcoming" : "Completed";
// //   const headerLabel = applied.tab === "forthcoming" ? "Forthcoming Events" : "Past Events";

// //   /* Count active filters for badge */
// //   const activeFilterCount = [applied.keywords, applied.eventType, applied.subject, applied.eventDate, applied.onlineType, applied.regions].filter(Boolean).length;

// //   const sidebarProps = {
// //     draftTab,
// //     draftKeywords,
// //     draftEventType,
// //     draftEventDate,
// //     draftSubject,
// //     draftOnlineType,
// //     draftRegions,
// //     setDraftKeywords,
// //     setDraftEventType,
// //     setDraftEventDate,
// //     setDraftSubject,
// //     setDraftOnlineType,
// //     setDraftRegions,
// //     handleSidebarStatus,
// //     handleSearch,
// //     handleClear,
// //     eventTypes,
// //     subjects,
// //     onlineTypes,
// //     regions,
// //   };

// //   return (
// //     <div id="top" className="min-h-screen bg-gray-50 text-gray-900">
// //       <style>{`
// //         @keyframes ev-fade-up {
// //           from { opacity: 0; transform: translateY(16px); }
// //           to { opacity: 1; transform: translateY(0); }
// //         }
// //         @keyframes ev-fade-in {
// //           from { opacity: 0; }
// //           to { opacity: 1; }
// //         }
// //         @keyframes ev-slide-in {
// //           from { transform: translateX(-100%); }
// //           to { transform: translateX(0); }
// //         }
// //         @keyframes ev-backdrop-in {
// //           from { opacity: 0; }
// //           to { opacity: 1; }
// //         }
// //         .ev-fade-up { animation: ev-fade-up 0.5s cubic-bezier(.2,.8,.2,1) both; }
// //         .ev-fade-in { animation: ev-fade-in 0.4s ease both; }
// //         .ev-slide-in { animation: ev-slide-in 0.3s cubic-bezier(.2,.8,.2,1) both; }
// //         .ev-backdrop-in { animation: ev-backdrop-in 0.25s ease both; }
// //       `}</style>

// //       {/* ── Hero ── */}
// // <header className="relative overflow-hidden bg-red-900 py-20 text-center text-white sm:py-24">
// //   {/* Background Image with Overlay */}
// //   <div 
// //     className="absolute inset-0 bg-cover bg-center bg-no-repeat"
// //     style={{ backgroundImage: "url('/Event.jpg')" }}
// //   />
// //   <div className="absolute inset-0 bg-gradient-to-t from-red-950/90 via-red-900/80 to-black/60" />

// //   {/* Top Left Breadcrumb Container */}
// //   <div className="absolute left-4 top-4 z-20 sm:left-8 sm:top-6">
// //     <Breadcrumb />
// //   </div>

// //   {/* Decorative Circles */}
// //   <span className="absolute -left-12 top-6 h-36 w-36 rounded-full bg-white/10 blur-sm pointer-events-none" />
// //   <span className="absolute -right-10 bottom-0 h-44 w-44 rounded-full bg-white/10 blur-sm pointer-events-none" />

// //   {/* Centered Main Content */}
// //   <div className="ev-fade-up relative z-10 mx-auto flex max-w-3xl flex-col items-center justify-center px-4 pt-6">
// //     <p className="text-xs font-semibold uppercase tracking-[0.25em] text-red-200 drop-shadow">
// //       Stay ahead of the industry calendar
// //     </p>
    
// //     <h1 className="mt-3 text-3xl font-extrabold tracking-tight text-white drop-shadow-md sm:text-5xl">
// //       ASSOCHAM Events
// //     </h1>
    
// //     <div className="mt-4 h-1 w-20 rounded-full bg-white/70 shadow-sm" />
// //   </div>
// // </header>

// // {/* ── Mobile filter FAB ── */}
// // <button
// //   type="button"
// //   onClick={() => setFilterOpen(true)}
// //   className="fixed bottom-5 right-5 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-red-700 text-white shadow-lg shadow-red-700/30 transition-all duration-200 hover:bg-red-800 hover:shadow-xl active:scale-95 lg:hidden"
// //   aria-label="Open filters"
// // >
// //   <FilterIcon className="h-5 w-5" />
// //   {activeFilterCount > 0 && (
// //     <span className="absolute -right-1 -top-1 flex h-5 w-5 items-center justify-center rounded-full bg-amber-500 text-[10px] font-bold text-white">
// //       {activeFilterCount}
// //     </span>
// //   )}
// // </button>

// // {/* ── Mobile filter drawer overlay ── */}
// // {filterOpen && (
// //   <div className="fixed inset-0 z-50 lg:hidden">
// //     {/* Backdrop */}
// //     <div
// //       className="ev-backdrop-in absolute inset-0 bg-black/40 backdrop-blur-sm"
// //       onClick={() => setFilterOpen(false)}
// //     />

// //     {/* Drawer panel */}
// //     <div className="ev-slide-in absolute bottom-0 left-0 top-0 flex w-[85%] max-w-[340px] flex-col bg-white shadow-2xl">
// //       {/* Drawer header */}
// //       <div className="flex items-center justify-between border-b border-gray-100 px-5 py-4">
// //         <div>
// //           <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-gray-400">Filter by</p>
// //           <h2 className="mt-0.5 text-lg font-bold text-gray-900">Events Search</h2>
// //         </div>
// //         <button
// //           type="button"
// //           onClick={() => setFilterOpen(false)}
// //           className="flex h-9 w-9 items-center justify-center rounded-full bg-gray-100 text-gray-500 transition hover:bg-gray-200 hover:text-gray-700"
// //           aria-label="Close filters"
// //         >
// //           <CloseIcon className="h-4 w-4" />
// //         </button>
// //       </div>

// //       {/* Drawer body (scrollable) */}
// //       <div className="flex-1 overflow-y-auto px-5 py-4">
// //         <SidebarContent {...sidebarProps} />
// //       </div>
// //     </div>
// //   </div>
// // )}

// //       {/* ── Content ── */}
// //       <section className="relative">
// //         <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8 lg:py-10">
// //           <div className="grid gap-6 lg:grid-cols-[280px_minmax(0,1fr)] xl:grid-cols-[300px_minmax(0,1fr)]">

// //             {/* ── Desktop Sidebar (hidden on mobile) ── */}
// //             <aside className="ev-fade-up hidden rounded-2xl border border-gray-200 bg-white p-5 shadow-sm lg:sticky lg:top-5 lg:block lg:h-fit">
// //               <div className="mb-4 border-b border-gray-100 pb-3">
// //                 <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-gray-400">Filter by</p>
// //                 <h2 className="mt-1 text-lg font-bold text-gray-900">Events Search</h2>
// //               </div>
// //               <SidebarContent {...sidebarProps} />
// //             </aside>

// //             {/* ── Main content ── */}
// //             <main className="space-y-5">
// //               {/* Header card */}
// //               <div className="ev-fade-up rounded-2xl border border-gray-200 bg-white p-4 shadow-sm sm:p-6">
// //                 <div className="flex flex-col gap-4 border-b border-gray-100 pb-4 sm:flex-row sm:items-center sm:justify-between">
// //                   <div>
// //                     <span className="inline-flex items-center gap-1.5 rounded-full bg-red-50 px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-red-700">
// //                       <span className="h-1.5 w-1.5 rounded-full bg-red-500 animate-pulse" />
// //                       Events Directory
// //                     </span>
// //                     <h1 className="mt-2 text-xl font-bold text-gray-900 sm:text-2xl md:text-[26px]">
// //                       {headerLabel}
// //                     </h1>
// //                   </div>

// //                   {/* Tab toggle */}
// //                   <div className="relative flex items-center gap-0.5 self-start rounded-lg border border-gray-200 bg-gray-50 p-1">
// //                     <div
// //                       className={`pointer-events-none absolute top-1 h-[calc(100%-8px)] rounded-md bg-red-700 shadow-sm transition-all duration-300 ease-out ${
// //                         activeTab === "forthcoming"
// //                           ? "left-1 w-[calc(55%-2px)]"
// //                           : "left-[calc(55%+1px)] w-[calc(45%-2px)]"
// //                       }`}
// //                     />
// //                     <button
// //                       type="button"
// //                       onClick={() => handleTab("forthcoming")}
// //                       className={`relative z-10 rounded-md px-3 py-1.5 text-sm font-medium transition-colors duration-200 sm:px-4 ${
// //                         activeTab === "forthcoming" ? "text-white" : "text-gray-500 hover:text-gray-700"
// //                       }`}
// //                     >
// //                       Forthcoming
// //                     </button>
// //                     <button
// //                       type="button"
// //                       onClick={() => handleTab("past")}
// //                       className={`relative z-10 rounded-md px-3 py-1.5 text-sm font-medium transition-colors duration-200 sm:px-4 ${
// //                         activeTab === "past" ? "text-white" : "text-gray-500 hover:text-gray-700"
// //                       }`}
// //                     >
// //                       Past
// //                     </button>
// //                   </div>
// //                 </div>

// //                 {/* Results summary */}
// //                 <div key={animKey} className="ev-fade-in mt-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
// //                   <div className="flex items-center gap-3">
// //                     <div className="rounded-lg bg-red-50 px-3 py-2">
// //                       <p className="text-[10px] font-semibold uppercase tracking-wider text-red-600">Results</p>
// //                       <p className="mt-0.5 text-xl font-bold text-gray-900">
// //                         <AnimatedNumber value={totalCount} />
// //                       </p>
// //                     </div>
// //                     <div>
// //                       <h2 className="text-base font-bold text-gray-900 sm:text-lg">Events ({totalCount})</h2>
// //                       <p className="text-xs text-gray-500 sm:text-sm">
// //                         {totalCount === 0 ? "No events match your filters" : `Showing 1–${Math.min(10, totalCount)} results`}
// //                       </p>
// //                     </div>
// //                   </div>
// //                   <div className="inline-flex items-center gap-1.5 self-start rounded-full bg-blue-50 px-3 py-1 text-xs font-medium text-blue-700">
// //                     <span className="h-1.5 w-1.5 rounded-full bg-blue-500 animate-pulse" />
// //                     Status: {statusLabel}
// //                   </div>
// //                 </div>

// //                 {/* Active filters display */}
// //                 {(applied.keywords || applied.eventType || applied.subject) && (
// //                   <div className="mt-3 flex flex-wrap items-center gap-1.5">
// //                     <span className="text-[10px] font-semibold uppercase tracking-wider text-gray-400">Filters:</span>
// //                     {applied.keywords && (
// //                       <span className="rounded-full bg-red-50 px-2.5 py-0.5 text-xs font-medium text-red-700">
// //                         &ldquo;{applied.keywords}&rdquo;
// //                       </span>
// //                     )}
// //                     {applied.eventType && (
// //                       <span className="rounded-full bg-amber-50 px-2.5 py-0.5 text-xs font-medium text-amber-700">
// //                         {applied.eventType}
// //                       </span>
// //                     )}
// //                     {applied.subject && (
// //                       <span className="rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-600">
// //                         {applied.subject}
// //                       </span>
// //                     )}
// //                   </div>
// //                 )}
// //               </div>

// //               {/* Event list */}
// //               <div key={`list-${animKey}`} className="grid gap-3">
// //                 {activeEvents.length === 0 ? (
// //                   <div className="ev-fade-up rounded-2xl border border-dashed border-gray-300 bg-white p-8 text-center sm:p-10">
// //                     <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-red-50 text-red-600">
// //                       <svg viewBox="0 0 24 24" className="h-5 w-5 fill-none" stroke="currentColor" strokeWidth="2">
// //                         <circle cx="11" cy="11" r="7" />
// //                         <path d="m20 20-3.5-3.5" />
// //                       </svg>
// //                     </div>
// //                     <h3 className="mt-3 text-lg font-semibold text-gray-900">No matching events</h3>
// //                     <p className="mx-auto mt-1.5 max-w-sm text-sm text-gray-500">
// //                       Try clearing some filters or switching the status tab.
// //                     </p>
// //                     <button
// //                       type="button"
// //                       onClick={handleClear}
// //                       className="mt-4 inline-flex items-center gap-1.5 rounded-lg bg-red-700 px-4 py-2 text-sm font-semibold text-white transition hover:bg-red-800"
// //                     >
// //                       Reset filters
// //                     </button>
// //                   </div>
// //                 ) : (
// //                   activeEvents.map((event, index) => (
// //                     <EventCard
// //                       key={`${activeTab}-${event.title}-${animKey}`}
// //                       event={event}
// //                       active={activeTab === "forthcoming"}
// //                       index={index}
// //                     />
// //                   ))
// //                 )}
// //               </div>

// //               {/* CTA Banner */}
// //               {/* <div className="ev-fade-up rounded-2xl bg-red-700 p-5 text-white sm:p-8">
// //                 <div className="flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between">
// //                   <div>
// //                     <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-red-200">Stay Updated</p>
// //                     <h3 className="mt-1.5 text-lg font-bold sm:text-xl md:text-2xl">Never miss the next flagship event</h3>
// //                     <p className="mt-2 max-w-lg text-sm leading-relaxed text-red-100">
// //                       Follow major conclaves, conferences, roadshows, awards, and summits across business, fintech, education, healthcare, and manufacturing sectors.
// //                     </p>
// //                   </div>
// //                   <div className="flex flex-col gap-2 sm:flex-row">
// //                     <button
// //                       type="button"
// //                       className="inline-flex w-fit items-center gap-1.5 rounded-lg bg-white px-4 py-2 text-sm font-semibold text-red-700 shadow-sm transition duration-200 hover:bg-red-50 sm:px-5 sm:py-2.5"
// //                     >
// //                       Get Event Alerts
// //                       <svg viewBox="0 0 24 24" className="h-3.5 w-3.5 fill-none" stroke="currentColor" strokeWidth="2.2">
// //                         <path d="M5 12h14" />
// //                         <path d="m13 5 7 7-7 7" />
// //                       </svg>
// //                     </button>
// //                     <button
// //                       type="button"
// //                       className="inline-flex w-fit items-center gap-1.5 rounded-lg border border-white/30 bg-white/10 px-4 py-2 text-sm font-medium text-white backdrop-blur-sm transition duration-200 hover:bg-white/20 sm:px-5 sm:py-2.5"
// //                     >
// //                       Download Calendar
// //                     </button>
// //                   </div>
// //                 </div>
// //               </div> */}
// //             </main>
// //           </div>
// //         </div>
// //       </section>
// //     </div>
// //   );
// // }






// // new code 





// import { useEffect, useMemo, useState, useCallback } from "react";

// // Production Base URL for ASSOCHAM
// const BASE_URL = "https://www.assocham.org";

// // Helper to load real database images from assocham.org with correct fallbacks
// function getEventImage(event) {
//   if (event.image) {
//     if (event.image.startsWith("http")) {
//       return event.image;
//     }
//     if (event.image.startsWith("/")) {
//       return `${BASE_URL}${event.image}`;
//     }
//     if (event.image.startsWith("assets/")) {
//       return `${BASE_URL}/${event.image}`;
//     }
//     return `${BASE_URL}/assets/images/${event.image}`;
//   }
//   // Actual production header image from assocham.org as the ultimate fallback
//   return `${BASE_URL}/assets/images/events-banner-main.jpg`;
// }

// /* ─── Animated counter ─── */
// function AnimatedNumber({ value, duration = 700 }) {
//   const [display, setDisplay] = useState(0);
//   useEffect(() => {
//     let raf;
//     const start = performance.now();
//     const tick = (now) => {
//       const progress = Math.min((now - start) / duration, 1);
//       const eased = 1 - Math.pow(1 - progress, 3);
//       setDisplay(Math.round(value * eased));
//       if (progress < 1) raf = requestAnimationFrame(tick);
//     };
//     raf = requestAnimationFrame(tick);
//     return () => cancelAnimationFrame(raf);
//   }, [value, duration]);
//   return <span>{display}</span>;
// }

// /* ─── Event image thumbnail ─── */
// function EventImageCard({ event, active }) {
//   const dateStr = event.date || "01 Jan, 2026";
//   const parts = dateStr.split(" ");
//   const dayPart = parts[0] || "01";
//   const restPart = parts.slice(1).join(" ");
//   const [monthPart] = restPart.split(",");
//   const finalMonth = monthPart || "JAN";
  
//   const yearMatch = dateStr.match(/(20\d{2})/);
//   const year = yearMatch ? yearMatch[1] : "2026";
//   const imageUrl = getEventImage(event);

//   return (
//     <div className="relative mx-auto flex h-[130px] w-[150px] shrink-0 overflow-hidden rounded-2xl shadow-sm transition-all duration-400 group-hover:-translate-y-0.5 group-hover:shadow-md sm:mx-0">
//       <img
//         src={imageUrl}
//         alt={event.title}
//         className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
//         loading="lazy"
//         onError={(e) => {
//           // If the image fails to load, substitute with the actual assocham.org main banner fallback
//           e.target.src = `${BASE_URL}/assets/images/events-banner-main.jpg`;
//         }}
//       />
//       <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/25 to-transparent" />

//       {/* Type badge */}
//       <div className="absolute right-2 top-2 z-10">
//         <span className="inline-block rounded-md bg-black/45 px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wider text-white/90 backdrop-blur-sm">
//           {event.type || "Summit"}
//         </span>
//       </div>

//       {/* Date overlay */}
//       <div className="absolute bottom-0 left-0 right-0 z-10 px-3 py-2.5">
//         <div className="flex items-end justify-between">
//           <div>
//             <div className="text-2xl font-bold leading-none text-white">{dayPart}</div>
//             <div className="mt-0.5 text-[10px] font-semibold uppercase tracking-widest text-amber-300">
//               {finalMonth}
//             </div>
//           </div>
//           <div
//             className={`rounded-md px-1.5 py-0.5 text-[10px] font-semibold text-white ${
//               active ? "bg-red-700" : "bg-gray-600"
//             }`}
//           >
//             {year}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// /* ─── Event card ─── */
// function EventCard({ event, active }) {
//   const isExternal = event.externalIndicator === 1;
//   const redirectUrl = event.redirectUrl 
//     ? (event.redirectUrl.startsWith("http") ? event.redirectUrl : `${BASE_URL}/${event.redirectUrl}`)
//     : "#";

//   const linkProps = {
//     href: redirectUrl,
//     target: isExternal ? "_blank" : "_self",
//     rel: isExternal ? "noopener noreferrer" : undefined,
//   };

//   return (
//     <article className="ev-fade-up group relative overflow-hidden rounded-2xl border border-gray-200 bg-white p-4 shadow-sm transition-all duration-300 hover:border-gray-300 hover:shadow-md sm:p-5">
//       <div className="relative flex flex-col gap-4 sm:flex-row sm:items-start">
//         <a {...linkProps} className="shrink-0 transition duration-200 hover:opacity-95">
//           <EventImageCard event={event} active={active} />
//         </a>

//         <div className="min-w-0 flex-1 space-y-2.5">
//           {/* Tags */}
//           <div className="flex flex-wrap items-center gap-1.5">
//             <span className="inline-flex rounded-full bg-red-50 px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wide text-red-700">
//               {event.category || "General"}
//             </span>
//             <span className="inline-flex rounded-full border border-amber-200 bg-amber-50 px-2.5 py-0.5 text-[11px] font-medium text-amber-700">
//               {event.accent || "Industry"}
//             </span>
//             {active ? (
//               <span className="inline-flex items-center gap-1 rounded-full bg-emerald-50 px-2.5 py-0.5 text-[11px] font-semibold text-emerald-700">
//                 <span className="relative flex h-1.5 w-1.5">
//                   <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-500 opacity-75" />
//                   <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-emerald-500" />
//                 </span>
//                 Upcoming
//               </span>
//             ) : (
//               <span className="inline-flex rounded-full bg-gray-100 px-2.5 py-0.5 text-[11px] font-medium text-gray-500">
//                 Archived
//               </span>
//             )}
//           </div>

//           {/* Title */}
//           <h3 className="text-[15px] font-semibold leading-snug text-gray-900 transition-colors duration-300 group-hover:text-red-700 sm:text-base">
//             <a {...linkProps} className="hover:underline">
//               {event.title}
//             </a>
//           </h3>

//           {/* Date + CTA */}
//           <div className="flex flex-col gap-2.5 sm:flex-row sm:items-center sm:justify-between">
//             <div className="flex items-center gap-2 text-sm text-gray-500">
//               <span className="inline-flex h-6 w-6 items-center justify-center rounded-full bg-red-700 text-white">
//                 <svg viewBox="0 0 24 24" className="h-3 w-3 fill-none" stroke="currentColor" strokeWidth="2.2">
//                   <path d="M8 2v4" />
//                   <path d="M16 2v4" />
//                   <rect x="3" y="5" width="18" height="16" rx="2" />
//                   <path d="M3 10h18" />
//                 </svg>
//               </span>
//               <span className="font-medium">{event.date}</span>
//             </div>

//             <a
//               {...linkProps}
//               className="inline-flex w-fit items-center gap-1.5 rounded-lg bg-red-700 px-3.5 py-1.5 text-[13px] font-semibold text-white shadow-sm transition-all duration-200 hover:bg-red-800 active:scale-[0.98] decoration-none hover:text-white"
//             >
//               {active ? "Register Interest" : "View Highlights"}
//               <svg viewBox="0 0 24 24" className="h-3.5 w-3.5 transition-transform duration-200 group-hover:translate-x-0.5" fill="none" stroke="currentColor" strokeWidth="2.2">
//                 <path d="M5 12h14" />
//                 <path d="m13 5 7 7-7 7" />
//               </svg>
//             </a>
//           </div>
//         </div>
//       </div>
//     </article>
//   );
// }

// /* ─── Skeleton Loader Card ─── */
// function EventCardSkeleton() {
//   return (
//     <article className="animate-pulse rounded-2xl border border-gray-200 bg-white p-4 shadow-sm sm:p-5">
//       <div className="relative flex flex-col gap-4 sm:flex-row sm:items-start">
//         <div className="h-[130px] w-[150px] shrink-0 rounded-2xl bg-gray-200" />
//         <div className="min-w-0 flex-1 space-y-3.5 py-1">
//           <div className="flex gap-2">
//             <div className="h-5 w-24 rounded-full bg-gray-200" />
//             <div className="h-5 w-16 rounded-full bg-gray-200" />
//             <div className="h-5 w-16 rounded-full bg-gray-200" />
//           </div>
//           <div className="space-y-2">
//             <div className="h-4 w-11/12 rounded bg-gray-200" />
//             <div className="h-4 w-2/3 rounded bg-gray-200" />
//           </div>
//           <div className="flex flex-col gap-3 pt-1 sm:flex-row sm:items-center sm:justify-between">
//             <div className="h-5 w-36 rounded bg-gray-200" />
//             <div className="h-8 w-28 rounded-lg bg-gray-200" />
//           </div>
//         </div>
//       </div>
//     </article>
//   );
// }

// /* ─── Select field ─── */
// function SelectField({ label, value, options, onChange, placeholder = "Select" }) {
//   return (
//     <div className="space-y-1">
//       <label className="text-xs font-medium text-gray-600">{label}</label>
//       <div className="relative">
//         <select
//           value={value}
//           onChange={(e) => onChange(e.target.value)}
//           className="w-full appearance-none rounded-lg border border-gray-200 bg-white py-2 pl-3 pr-9 text-sm text-gray-700 transition duration-200 hover:border-gray-300 focus:border-red-500 focus:outline-none focus:ring-2 focus:ring-red-100"
//         >
//           <option value="">{placeholder}</option>
//           {options.map((opt) => (
//             <option key={opt} value={opt}>
//               {opt}
//             </option>
//           ))}
//         </select>
//         <svg viewBox="0 0 24 24" className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" fill="none" stroke="currentColor" strokeWidth="2">
//           <path d="m6 9 6 6 6-6" />
//         </svg>
//       </div>
//     </div>
//   );
// }

// /* ─── Breadcrumb ─── */
// function Breadcrumb() {
//   return (
//     <nav aria-label="Breadcrumb" className="ev-fade-in absolute left-4 top-4 z-20 sm:left-8 sm:top-5">
//       <ol className="flex items-center gap-2 rounded-full border border-white/20 bg-white/15 px-4 py-1.5 text-xs font-medium text-white/90 backdrop-blur-md">
//         <li>
//           <a href={`${BASE_URL}`} className="inline-flex items-center gap-1.5 transition-colors hover:text-white">
//             <svg viewBox="0 0 24 24" className="h-3.5 w-3.5" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
//               <path d="M3 10.5 12 3l9 7.5" />
//               <path d="M5 10v10h14V10" />
//               <path d="M9 20v-6h6v6" />
//             </svg>
//             Home
//           </a>
//         </li>
//         <li className="text-white/40">›</li>
//         <li className="font-semibold text-white">Events</li>
//       </ol>
//     </nav>
//   );
// }

// /* ─── Filter icon SVGs ─── */
// function FilterIcon({ className = "h-5 w-5" }) {
//   return (
//     <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//       <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
//     </svg>
//   );
// }

// function CloseIcon({ className = "h-5 w-5" }) {
//   return (
//     <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//       <line x1="18" y1="6" x2="6" y2="18" />
//       <line x1="6" y1="6" x2="18" y2="18" />
//     </svg>
//   );
// }

// /* ─── Sidebar content (shared between mobile & desktop) ─── */
// function SidebarContent({
//   draftTab,
//   draftKeywords,
//   draftEventType,
//   draftEventDate,
//   draftSubject,
//   draftOnlineType,
//   draftRegions,
//   setDraftKeywords,
//   setDraftEventType,
//   setDraftEventDate,
//   setDraftSubject,
//   setDraftOnlineType,
//   setDraftRegions,
//   handleSidebarStatus,
//   handleSearch,
//   handleClear,
//   eventTypes,
//   subjects,
//   onlineTypes,
//   regions,
// }) {
//   return (
//     <>
//       <div className="space-y-3">
//         {/* Keywords */}
//         <div className="space-y-1">
//           <label className="text-xs font-medium text-gray-600">Keywords</label>
//           <div className="relative">
//             <svg viewBox="0 0 24 24" className="pointer-events-none absolute left-3 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-gray-400" fill="none" stroke="currentColor" strokeWidth="2">
//               <circle cx="11" cy="11" r="7" />
//               <path d="m20 20-3.5-3.5" />
//             </svg>
//             <input
//               type="text"
//               value={draftKeywords}
//               onChange={(e) => setDraftKeywords(e.target.value)}
//               onKeyDown={(e) => e.key === "Enter" && handleSearch()}
//               placeholder="Search by title, sector…"
//               className="w-full rounded-lg border border-gray-200 bg-white py-2 pl-9 pr-3 text-sm text-gray-700 transition duration-200 placeholder:text-gray-400 hover:border-gray-300 focus:border-red-500 focus:outline-none focus:ring-2 focus:ring-red-100"
//             />
//           </div>
//         </div>

//         {/* Status toggle */}
//         <div className="space-y-1">
//           <label className="text-xs font-medium text-gray-600">Status</label>
//           <div className="flex gap-1 rounded-lg border border-gray-200 bg-gray-50 p-1">
//             <button
//               type="button"
//               onClick={() => handleSidebarStatus("forthcoming")}
//               className={`flex-1 rounded-md px-3 py-1.5 text-sm font-medium transition duration-200 ${
//                 draftTab === "forthcoming"
//                   ? "bg-red-700 text-white shadow-sm"
//                   : "text-gray-500 hover:text-gray-700"
//               }`}
//             >
//               Forthcoming
//             </button>
//             <button
//               type="button"
//               onClick={() => handleSidebarStatus("past")}
//               className={`flex-1 rounded-md px-3 py-1.5 text-sm font-medium transition duration-200 ${
//                 draftTab === "past"
//                   ? "bg-red-700 text-white shadow-sm"
//                   : "text-gray-500 hover:text-gray-700"
//               }`}
//             >
//               Past
//             </button>
//           </div>
//         </div>

//         <SelectField label="Event type" value={draftEventType} options={eventTypes} onChange={setDraftEventType} placeholder="All types" />
//         <SelectField label="Date range" value={draftEventDate} options={["This Week", "This Month", "Next 3 Months", "This Quarter", "This Year"]} onChange={setDraftEventDate} placeholder="Any date" />
//         <SelectField label="Subject" value={draftSubject} options={subjects} onChange={setDraftSubject} placeholder="All subjects" />
//         <SelectField label="Format" value={draftOnlineType} options={onlineTypes} onChange={setDraftOnlineType} placeholder="All formats" />
//         <SelectField label="Region" value={draftRegions} options={regions} onChange={setDraftRegions} placeholder="All regions" />
//       </div>

//       {/* Action buttons */}
//       <div className="mt-5 flex gap-2">
//         <button
//           type="button"
//           onClick={handleSearch}
//           className="flex flex-1 items-center justify-center gap-1.5 rounded-lg bg-red-700 px-4 py-2 text-sm font-semibold text-white transition duration-200 hover:bg-red-800"
//         >
//           <svg viewBox="0 0 24 24" className="h-3.5 w-3.5 fill-none" stroke="currentColor" strokeWidth="2.2">
//             <circle cx="11" cy="11" r="7" />
//             <path d="m20 20-3.5-3.5" />
//           </svg>
//           Search
//         </button>
//         <button
//           type="button"
//           onClick={handleClear}
//           className="flex flex-1 items-center justify-center gap-1.5 rounded-lg border border-gray-200 bg-white px-4 py-2 text-sm font-medium text-gray-600 transition duration-200 hover:bg-gray-50"
//         >
//           Clear
//         </button>
//       </div>

//       {/* Help box */}
//       <div className="mt-5 rounded-xl border border-amber-200 bg-amber-50 p-3.5">
//         <p className="text-[10px] font-semibold uppercase tracking-[0.15em] text-amber-700">Need assistance?</p>
//         <p className="mt-1.5 text-xs leading-relaxed text-gray-600">
//           Looking to partner, sponsor, or nominate for an awards category? Connect with the events desk.
//         </p>
//         <a 
//           href="mailto:events@assocham.com" 
//           className="mt-2.5 inline-flex items-center gap-1 text-xs font-semibold text-red-700 transition hover:gap-2 hover:text-red-800"
//         >
//           Contact Team
//           <svg viewBox="0 0 24 24" className="h-3.5 w-3.5 fill-none" stroke="currentColor" strokeWidth="2.2">
//             <path d="M5 12h14" />
//             <path d="m13 5 7 7-7 7" />
//           </svg>
//         </a>
//       </div>
//     </>
//   );
// }

// /* ─── Main page ─── */
// export default function EventPage() {
//   const [allEvents, setAllEvents] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const [activeTab, setActiveTab] = useState("forthcoming");
//   const [draftTab, setDraftTab] = useState("forthcoming");
//   const [draftKeywords, setDraftKeywords] = useState("");
//   const [draftEventType, setDraftEventType] = useState("");
//   const [draftEventDate, setDraftEventDate] = useState("");
//   const [draftSubject, setDraftSubject] = useState("");
//   const [draftOnlineType, setDraftOnlineType] = useState("");
//   const [draftRegions, setDraftRegions] = useState("");
//   const [filterOpen, setFilterOpen] = useState(false);

//   const [applied, setApplied] = useState({
//     tab: "forthcoming",
//     keywords: "",
//     eventType: "",
//     eventDate: "",
//     subject: "",
//     onlineType: "",
//     regions: "",
//   });

//   const [animKey, setAnimKey] = useState(0);

//   // Load live production events dynamically from assocham.org
//   useEffect(() => {
//     setLoading(true);
//     setError(null);
//     fetch(`${BASE_URL}/api/get_events.php`)
//       .then((res) => {
//         if (!res.ok) {
//           throw new Error(`HTTP Error! Status Code: ${res.status}`);
//         }
//         return res.json();
//       })
//       .then((result) => {
//         if (result.success && Array.isArray(result.data)) {
//           setAllEvents(result.data);
//         } else {
//           throw new Error(result.error || "Failed to retrieve dynamic database rows.");
//         }
//         setLoading(false);
//       })
//       .catch((err) => {
//         console.error("Failed to fetch production ASSOCHAM events:", err);
//         setError(err.message);
//         setLoading(false);
//       });
//   }, []);

//   // Recalculate dropdown filter options dynamically as live rows load
//   const eventTypes = useMemo(() => Array.from(new Set(allEvents.map((e) => e.type).filter(Boolean))), [allEvents]);
//   const subjects = useMemo(() => Array.from(new Set(allEvents.map((e) => e.accent).filter(Boolean))), [allEvents]);
//   const onlineTypes = ["In-Person", "Virtual", "Hybrid"];
//   const regions = ["Delhi NCR", "Mumbai", "Odisha", "Gujarat", "Telangana", "Rajasthan", "Pan-India"];

//   /* Lock body scroll when mobile drawer is active */
//   useEffect(() => {
//     if (filterOpen) {
//       document.body.style.overflow = "hidden";
//     } else {
//       document.body.style.overflow = "";
//     }
//     return () => {
//       document.body.style.overflow = "";
//     };
//   }, [filterOpen]);

//   const applyFilters = useCallback((next) => {
//     setApplied(next);
//     setActiveTab(next.tab);
//     setDraftTab(next.tab);
//     setAnimKey((k) => k + 1);
//   }, []);

//   const handleTab = (tab) => {
//     setActiveTab(tab);
//     setDraftTab(tab);
//     setApplied((prev) => ({ ...prev, tab }));
//     setAnimKey((k) => k + 1);
//   };

//   const handleSidebarStatus = (tab) => {
//     setDraftTab(tab);
//     setActiveTab(tab);
//     setApplied((prev) => ({
//       ...prev,
//       tab,
//       keywords: draftKeywords.trim(),
//       eventType: draftEventType,
//       eventDate: draftEventDate,
//       subject: draftSubject,
//       onlineType: draftOnlineType,
//       regions: draftRegions,
//     }));
//     setAnimKey((k) => k + 1);
//   };

//   const handleSearch = useCallback(() => {
//     applyFilters({
//       tab: draftTab,
//       keywords: draftKeywords.trim(),
//       eventType: draftEventType,
//       eventDate: draftEventDate,
//       subject: draftSubject,
//       onlineType: draftOnlineType,
//       regions: draftRegions,
//     });
//     setFilterOpen(false);
//   }, [draftTab, draftKeywords, draftEventType, draftEventDate, draftSubject, draftOnlineType, draftRegions, applyFilters]);

//   const handleClear = useCallback(() => {
//     setDraftKeywords("");
//     setDraftEventType("");
//     setDraftEventDate("");
//     setDraftSubject("");
//     setDraftOnlineType("");
//     setDraftRegions("");
//     setDraftTab("forthcoming");
//     applyFilters({
//       tab: "forthcoming",
//       keywords: "",
//       eventType: "",
//       eventDate: "",
//       subject: "",
//       onlineType: "",
//       regions: "",
//     });
//     setFilterOpen(false);
//   }, [applyFilters]);

//   const activeEvents = useMemo(() => {
//     const base = allEvents.filter((e) => e.status === applied.tab);
//     const kw = applied.keywords.toLowerCase();
//     return base.filter((e) => {
//       if (applied.eventType && e.type !== applied.eventType) return false;
//       if (applied.subject && e.accent !== applied.subject) return false;
//       if (kw) {
//         const hay = `${e.title} ${e.category} ${e.accent}`.toLowerCase();
//         if (!hay.includes(kw)) return false;
//       }
//       return true;
//     });
//   }, [allEvents, applied]);

//   const totalCount = activeEvents.length;
//   const statusLabel = applied.tab === "forthcoming" ? "Upcoming" : "Completed";
//   const headerLabel = applied.tab === "forthcoming" ? "Forthcoming Events" : "Past Events";

//   /* Count active filters for badge */
//   const activeFilterCount = [applied.keywords, applied.eventType, applied.subject, applied.eventDate, applied.onlineType, applied.regions].filter(Boolean).length;

//   const sidebarProps = {
//     draftTab,
//     draftKeywords,
//     draftEventType,
//     draftEventDate,
//     draftSubject,
//     draftOnlineType,
//     draftRegions,
//     setDraftKeywords,
//     setDraftEventType,
//     setDraftEventDate,
//     setDraftSubject,
//     setDraftOnlineType,
//     setDraftRegions,
//     handleSidebarStatus,
//     handleSearch,
//     handleClear,
//     eventTypes,
//     subjects,
//     onlineTypes,
//     regions,
//   };

//   return (
//     <div id="top" className="min-h-screen bg-gray-50 text-gray-900">
//       <style>{`
//         @keyframes ev-fade-up {
//           from { opacity: 0; transform: translateY(16px); }
//           to { opacity: 1; transform: translateY(0); }
//         }
//         @keyframes ev-fade-in {
//           from { opacity: 0; }
//           to { opacity: 1; }
//         }
//         @keyframes ev-slide-in {
//           from { transform: translateX(-100%); }
//           to { transform: translateX(0); }
//         }
//         @keyframes ev-backdrop-in {
//           from { opacity: 0; }
//           to { opacity: 1; }
//         }
//         .ev-fade-up { animation: ev-fade-up 0.5s cubic-bezier(.2,.8,.2,1) both; }
//         .ev-fade-in { animation: ev-fade-in 0.4s ease both; }
//         .ev-slide-in { animation: ev-slide-in 0.3s cubic-bezier(.2,.8,.2,1) both; }
//         .ev-backdrop-in { animation: ev-backdrop-in 0.25s ease both; }
//       `}</style>

//       {/* ── Hero ── */}
//       <header className="relative overflow-hidden bg-red-900 py-20 text-center text-white sm:py-24">
//         {/* Background Image with Overlay */}
//         <div 
//           className="absolute inset-0 bg-cover bg-center bg-no-repeat"
//           style={{ backgroundImage: `url('${BASE_URL}/assets/images/events-banner-main.jpg')` }}
//         />
//         <div className="absolute inset-0 bg-gradient-to-t from-red-950/90 via-red-900/85 to-black/65" />

//         {/* Top Left Breadcrumb Container */}
//         <div className="absolute left-4 top-4 z-20 sm:left-8 sm:top-6">
//           <Breadcrumb />
//         </div>

//         {/* Centered Main Content */}
//         <div className="ev-fade-up relative z-10 mx-auto flex max-w-3xl flex-col items-center justify-center px-4 pt-6">
//           <p className="text-xs font-semibold uppercase tracking-[0.25em] text-red-200 drop-shadow">
//             Stay ahead of the industry calendar
//           </p>
          
//           <h1 className="mt-3 text-3xl font-extrabold tracking-tight text-white drop-shadow-md sm:text-5xl">
//             ASSOCHAM Events
//           </h1>
          
//           <div className="mt-4 h-1 w-20 rounded-full bg-white/70 shadow-sm" />
//         </div>
//       </header>

//       {/* ── Mobile filter FAB ── */}
//       <button
//         type="button"
//         onClick={() => setFilterOpen(true)}
//         className="fixed bottom-5 right-5 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-red-700 text-white shadow-lg shadow-red-700/30 transition-all duration-200 hover:bg-red-800 hover:shadow-xl active:scale-95 lg:hidden"
//         aria-label="Open filters"
//       >
//         <FilterIcon className="h-5 w-5" />
//         {activeFilterCount > 0 && (
//           <span className="absolute -right-1 -top-1 flex h-5 w-5 items-center justify-center rounded-full bg-amber-500 text-[10px] font-bold text-white">
//             {activeFilterCount}
//           </span>
//         )}
//       </button>

//       {/* ── Mobile filter drawer overlay ── */}
//       {filterOpen && (
//         <div className="fixed inset-0 z-50 lg:hidden">
//           {/* Backdrop */}
//           <div
//             className="ev-backdrop-in absolute inset-0 bg-black/40 backdrop-blur-sm"
//             onClick={() => setFilterOpen(false)}
//           />

//           {/* Drawer panel */}
//           <div className="ev-slide-in absolute bottom-0 left-0 top-0 flex w-[85%] max-w-[340px] flex-col bg-white shadow-2xl">
//             {/* Drawer header */}
//             <div className="flex items-center justify-between border-b border-gray-100 px-5 py-4">
//               <div>
//                 <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-gray-400">Filter by</p>
//                 <h2 className="mt-0.5 text-lg font-bold text-gray-900">Events Search</h2>
//               </div>
//               <button
//                 type="button"
//                 onClick={() => setFilterOpen(false)}
//                 className="flex h-9 w-9 items-center justify-center rounded-full bg-gray-100 text-gray-500 transition hover:bg-gray-200 hover:text-gray-700"
//                 aria-label="Close filters"
//               >
//                 <CloseIcon className="h-4 w-4" />
//               </button>
//             </div>

//             {/* Drawer body (scrollable) */}
//             <div className="flex-1 overflow-y-auto px-5 py-4">
//               <SidebarContent {...sidebarProps} />
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ── Content ── */}
//       <section className="relative">
//         <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8 lg:py-10">
//           <div className="grid gap-6 lg:grid-cols-[280px_minmax(0,1fr)] xl:grid-cols-[300px_minmax(0,1fr)]">

//             {/* ── Desktop Sidebar (hidden on mobile) ── */}
//             <aside className="ev-fade-up hidden rounded-2xl border border-gray-200 bg-white p-5 shadow-sm lg:sticky lg:top-5 lg:block lg:h-fit">
//               <div className="mb-4 border-b border-gray-100 pb-3">
//                 <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-gray-400">Filter by</p>
//                 <h2 className="mt-1 text-lg font-bold text-gray-900">Events Search</h2>
//               </div>
//               <SidebarContent {...sidebarProps} />
//             </aside>

//             {/* ── Main content ── */}
//             <main className="space-y-5">
//               {/* Header card */}
//               <div className="ev-fade-up rounded-2xl border border-gray-200 bg-white p-4 shadow-sm sm:p-6">
//                 <div className="flex flex-col gap-4 border-b border-gray-100 pb-4 sm:flex-row sm:items-center sm:justify-between">
//                   <div>
//                     <span className="inline-flex items-center gap-1.5 rounded-full bg-red-50 px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-red-700">
//                       <span className="h-1.5 w-1.5 rounded-full bg-red-500 animate-pulse" />
//                       Events Directory
//                     </span>
//                     <h1 className="mt-2 text-xl font-bold text-gray-900 sm:text-2xl md:text-[26px]">
//                       {headerLabel}
//                     </h1>
//                   </div>

//                   {/* Tab toggle */}
//                   <div className="relative flex items-center gap-0.5 self-start rounded-lg border border-gray-200 bg-gray-50 p-1">
//                     <div
//                       className={`pointer-events-none absolute top-1 h-[calc(100%-8px)] rounded-md bg-red-700 shadow-sm transition-all duration-300 ease-out ${
//                         activeTab === "forthcoming"
//                           ? "left-1 w-[calc(55%-2px)]"
//                           : "left-[calc(55%+1px)] w-[calc(45%-2px)]"
//                       }`}
//                     />
//                     <button
//                       type="button"
//                       onClick={() => handleTab("forthcoming")}
//                       className={`relative z-10 rounded-md px-3 py-1.5 text-sm font-medium transition-colors duration-200 sm:px-4 ${
//                         activeTab === "forthcoming" ? "text-white" : "text-gray-500 hover:text-gray-700"
//                       }`}
//                     >
//                       Forthcoming
//                     </button>
//                     <button
//                       type="button"
//                       onClick={() => handleTab("past")}
//                       className={`relative z-10 rounded-md px-3 py-1.5 text-sm font-medium transition-colors duration-200 sm:px-4 ${
//                         activeTab === "past" ? "text-white" : "text-gray-500 hover:text-gray-700"
//                       }`}
//                     >
//                       Past
//                     </button>
//                   </div>
//                 </div>

//                 {/* Results summary */}
//                 <div key={animKey} className="ev-fade-in mt-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
//                   <div className="flex items-center gap-3">
//                     <div className="rounded-lg bg-red-50 px-3 py-2">
//                       <p className="text-[10px] font-semibold uppercase tracking-wider text-red-600">Results</p>
//                       <p className="mt-0.5 text-xl font-bold text-gray-900">
//                         {loading ? "..." : <AnimatedNumber value={totalCount} />}
//                       </p>
//                     </div>
//                     <div>
//                       <h2 className="text-base font-bold text-gray-900 sm:text-lg">Events ({loading ? "Loading..." : totalCount})</h2>
//                       <p className="text-xs text-gray-500 sm:text-sm">
//                         {loading 
//                           ? "Fetching latest events from assocham.org..." 
//                           : totalCount === 0 
//                             ? "No events match your filters" 
//                             : `Showing 1–${Math.min(12, totalCount)} of ${totalCount} results`}
//                       </p>
//                     </div>
//                   </div>
//                   <div className="inline-flex items-center gap-1.5 self-start rounded-full bg-blue-50 px-3 py-1 text-xs font-medium text-blue-700">
//                     <span className="h-1.5 w-1.5 rounded-full bg-blue-500 animate-pulse" />
//                     Status: {statusLabel}
//                   </div>
//                 </div>

//                 {/* Active filters display */}
//                 {(applied.keywords || applied.eventType || applied.subject) && (
//                   <div className="mt-3 flex flex-wrap items-center gap-1.5">
//                     <span className="text-[10px] font-semibold uppercase tracking-wider text-gray-400">Filters:</span>
//                     {applied.keywords && (
//                       <span className="rounded-full bg-red-50 px-2.5 py-0.5 text-xs font-medium text-red-700">
//                         &ldquo;{applied.keywords}&rdquo;
//                       </span>
//                     )}
//                     {applied.eventType && (
//                       <span className="rounded-full bg-amber-50 px-2.5 py-0.5 text-xs font-medium text-amber-700">
//                         {applied.eventType}
//                       </span>
//                     )}
//                     {applied.subject && (
//                       <span className="rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-600">
//                         {applied.subject}
//                       </span>
//                     )}
//                   </div>
//                 )}
//               </div>

//               {/* Error Alert Banner */}
//               {error && (
//                 <div className="ev-fade-up rounded-2xl border border-red-200 bg-red-50 p-4 text-red-800">
//                   <div className="flex items-start gap-3">
//                     <svg viewBox="0 0 24 24" className="h-5 w-5 text-red-600 shrink-0" fill="none" stroke="currentColor" strokeWidth="2">
//                       <circle cx="12" cy="12" r="10" />
//                       <line x1="12" y1="8" x2="12" y2="12" />
//                       <line x1="12" y1="16" x2="12.01" y2="16" />
//                     </svg>
//                     <div>
//                       <h4 className="font-bold">Live Data Fetch Error</h4>
//                       <p className="mt-1 text-sm text-red-700">
//                         Failed to connect to the database API at <strong>assocham.org</strong>: <code>{error}</code>.
//                         Please ensure the backend API script is running and CORS is enabled.
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//               )}

//               {/* Event list */}
//               <div key={`list-${animKey}`} className="grid gap-3">
//                 {loading ? (
//                   // Show clean animated skeletons during fetching
//                   Array.from({ length: 4 }).map((_, i) => <EventCardSkeleton key={i} />)
//                 ) : activeEvents.length === 0 ? (
//                   <div className="ev-fade-up rounded-2xl border border-dashed border-gray-300 bg-white p-8 text-center sm:p-10">
//                     <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-red-50 text-red-600">
//                       <svg viewBox="0 0 24 24" className="h-5 w-5 fill-none" stroke="currentColor" strokeWidth="2">
//                         <circle cx="11" cy="11" r="7" />
//                         <path d="m20 20-3.5-3.5" />
//                       </svg>
//                     </div>
//                     <h3 className="mt-3 text-lg font-semibold text-gray-900">No matching events</h3>
//                     <p className="mx-auto mt-1.5 max-w-sm text-sm text-gray-500">
//                       Try clearing some filters or switching the status tab.
//                     </p>
//                     <button
//                       type="button"
//                       onClick={handleClear}
//                       className="mt-4 inline-flex items-center gap-1.5 rounded-lg bg-red-700 px-4 py-2 text-sm font-semibold text-white transition hover:bg-red-800"
//                     >
//                       Reset filters
//                     </button>
//                   </div>
//                 ) : (
//                   activeEvents.map((event, index) => (
//                     <EventCard
//                       key={`${activeTab}-${event.id || event.title}-${animKey}`}
//                       event={event}
//                       active={activeTab === "forthcoming"}
//                       index={index}
//                     />
//                   ))
//                 )}
//               </div>
//             </main>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// }





// new new code 




import { useCallback, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";

const BASE_URL = "https://www.assocham.org/assocham_backend";
const EVENTS_PER_PAGE = 10;

function getEventImage(event) {
  const image = event.image;
  if (!image) return `${BASE_URL}/assets/images/events-banner-main.jpg`;
  if (image.startsWith("http")) return image;
  if (image.startsWith("/")) return `${BASE_URL}${image}`;
  if (image.startsWith("assets/")) return `${BASE_URL}/${image}`;
  return `${BASE_URL}/assets/images/${image}`;
}

function EventImageCard({ event, active }) {
  const date = event.date || "01 Jan, 2026";
  const match = date.match(/(\d{1,2})\s+([A-Za-z]{3})[^\d]*(20\d{2})/);
  const day = match?.[1] || "01";
  const month = match?.[2] || "JAN";
  const year = match?.[3] || "2026";
  return <div className="relative mx-auto h-[140px] w-[255px] shrink-0 overflow-hidden rounded-2xl shadow-sm sm:mx-0"><img src={getEventImage(event)} alt={event.title} className="absolute inset-0 h-full w-full object-cover" onError={(e) => { e.currentTarget.src = `${BASE_URL}/assets/images/events-banner-main.jpg`; }} /><div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/25 to-transparent" /><span className="absolute right-2 top-2 rounded-md bg-black/45 px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wider text-white">{event.type || "Summit"}</span><div className="absolute bottom-0 left-0 right-0 flex items-end justify-between px-3 py-2.5"><div><p className="text-2xl font-bold leading-none text-white">{day}</p><p className="mt-0.5 text-[10px] font-semibold uppercase tracking-widest text-amber-300">{month}</p></div><span className={`rounded-md px-1.5 py-0.5 text-[10px] font-semibold text-white ${active ? "bg-red-700" : "bg-gray-600"}`}>{year}</span></div></div>;
}

function EventCard({ event, active }) {
  const isExternal = Number(event.externalIndicator) === 1 && event.externalUrl;
  const to = `/event-details/${event.slug}`;
  const externalUrl = event.externalUrl?.startsWith("http") ? event.externalUrl : `${BASE_URL}/${event.externalUrl || ""}`;
  const EventLink = ({ children, className }) => isExternal ? <a href={externalUrl} target="_blank" rel="noreferrer" className={className}>{children}</a> : <Link to={to} className={className}>{children}</Link>;
  return <article className="group rounded-2xl border border-gray-200 bg-white p-4 shadow-sm transition hover:shadow-md sm:p-5"><div className="flex flex-col gap-4 sm:flex-row"><EventLink className="shrink-0"><EventImageCard event={event} active={active} /></EventLink><div className="min-w-0 flex-1 space-y-3"><div className="flex flex-wrap gap-1.5"><span className="rounded-full bg-red-50 px-2.5 py-0.5 text-[11px] font-semibold uppercase text-red-700">{event.category || "General"}</span><span className="rounded-full border border-amber-200 bg-amber-50 px-2.5 py-0.5 text-[11px] font-medium text-amber-700">{event.accent || "Industry"}</span><span className={`rounded-full px-2.5 py-0.5 text-[11px] font-medium ${active ? "bg-emerald-50 text-emerald-700" : "bg-gray-100 text-gray-500"}`}>{active ? "Upcoming" : "Archived"}</span></div><h3 className="text-base font-semibold leading-snug text-gray-900 group-hover:text-red-700"><EventLink className="hover:underline">{event.title}</EventLink></h3><div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between"><p className="text-sm font-medium text-gray-500">📅 {event.date}</p><EventLink className="inline-flex w-fit items-center gap-2 rounded-lg bg-red-700 px-3.5 py-2 text-[13px] font-semibold text-white no-underline hover:bg-red-800">{active ? "Register Interest" : "View Highlights"} <span>→</span></EventLink></div></div></div></article>;
}

function SelectField({ label, value, options, onChange, placeholder }) { return <label className="block space-y-1 text-xs font-medium text-gray-600">{label}<select value={value} onChange={(e) => onChange(e.target.value)} className="block w-full rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm font-normal text-gray-700 outline-none focus:border-red-500"><option value="">{placeholder}</option>{options.map((option) => <option key={option} value={option}>{option}</option>)}</select></label>; }

function Filters({ draft, setDraft, search, clear, eventTypes, subjects }) {
  return <><div className="space-y-3"><label className="block space-y-1 text-xs font-medium text-gray-600">Keywords<input value={draft.keywords} onChange={(e) => setDraft({ ...draft, keywords: e.target.value })} onKeyDown={(e) => e.key === "Enter" && search()} placeholder="Search by title, sector…" className="block w-full rounded-lg border border-gray-200 px-3 py-2 text-sm outline-none focus:border-red-500" /></label><div><p className="mb-1 text-xs font-medium text-gray-600">Status</p><div className="flex rounded-lg bg-gray-100 p-1"><button onClick={() => setDraft({ ...draft, tab: "forthcoming" })} className={`flex-1 rounded-md py-1.5 text-sm ${draft.tab === "forthcoming" ? "bg-red-700 text-white" : "text-gray-500"}`}>Forthcoming</button><button onClick={() => setDraft({ ...draft, tab: "past" })} className={`flex-1 rounded-md py-1.5 text-sm ${draft.tab === "past" ? "bg-red-700 text-white" : "text-gray-500"}`}>Past</button></div></div><SelectField label="Event type" value={draft.eventType} options={eventTypes} onChange={(value) => setDraft({ ...draft, eventType: value })} placeholder="All types" /><SelectField label="Subject" value={draft.subject} options={subjects} onChange={(value) => setDraft({ ...draft, subject: value })} placeholder="All subjects" /></div><div className="mt-5 flex gap-2"><button onClick={search} className="flex-1 rounded-lg bg-red-700 px-4 py-2 text-sm font-bold text-white hover:bg-red-800">Search</button><button onClick={clear} className="flex-1 rounded-lg border border-gray-200 px-4 py-2 text-sm font-medium text-gray-600 hover:bg-gray-50">Clear</button></div></>;
}

function Pagination({ page, totalPages, onChange }) {
  const pages = (() => { if (totalPages <= 5) return Array.from({ length: totalPages }, (_, i) => i + 1); if (page <= 3) return [1, 2, 3, 4, "dots", totalPages]; if (page >= totalPages - 2) return [1, "dots", totalPages - 3, totalPages - 2, totalPages - 1, totalPages]; return [1, "dots-left", page - 1, page, page + 1, "dots-right", totalPages]; })();
  return <nav className="flex flex-wrap items-center justify-center gap-2 pt-4"><button onClick={() => onChange(page - 1)} disabled={page === 1} className="rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm font-semibold disabled:opacity-40">Previous</button>{pages.map((item, index) => typeof item === "string" ? <span key={`${item}-${index}`} className="px-1 font-bold text-gray-400">...</span> : <button key={item} onClick={() => onChange(item)} className={`flex h-10 min-w-10 items-center justify-center rounded-lg px-3 text-sm font-bold ${item === page ? "bg-red-700 text-white" : "border border-gray-200 bg-white text-gray-600 hover:text-red-700"}`}>{item}</button>)}<button onClick={() => onChange(page + 1)} disabled={page === totalPages} className="rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm font-semibold disabled:opacity-40">Next</button></nav>;
}

export default function EventPage() {
  const [allEvents, setAllEvents] = useState([]); const [loading, setLoading] = useState(true); const [error, setError] = useState(""); const [filterOpen, setFilterOpen] = useState(false); const [page, setPage] = useState(1);
  const initial = { tab: "forthcoming", keywords: "", eventType: "", subject: "" }; const [draft, setDraft] = useState(initial); const [applied, setApplied] = useState(initial);
  useEffect(() => { fetch(`${BASE_URL}/api/get_events.php`).then(async (res) => { const json = await res.json(); if (!res.ok || !json.success) throw new Error(json.error || "Could not load events."); return json.data; }).then(setAllEvents).catch((e) => setError(e.message)).finally(() => setLoading(false)); }, []);
  const eventTypes = useMemo(() => [...new Set(allEvents.map((e) => e.type).filter(Boolean))], [allEvents]); const subjects = useMemo(() => [...new Set(allEvents.map((e) => e.accent).filter(Boolean))], [allEvents]);
  const events = useMemo(() => allEvents.filter((e) => { if (e.status !== applied.tab) return false; if (applied.eventType && e.type !== applied.eventType) return false; if (applied.subject && e.accent !== applied.subject) return false; const haystack = `${e.title} ${e.category} ${e.accent}`.toLowerCase(); return !applied.keywords || haystack.includes(applied.keywords.toLowerCase()); }), [allEvents, applied]);
  const totalPages = Math.max(1, Math.ceil(events.length / EVENTS_PER_PAGE)); const pageEvents = useMemo(() => events.slice((page - 1) * EVENTS_PER_PAGE, page * EVENTS_PER_PAGE), [events, page]);
  const search = useCallback(() => { setApplied({ ...draft, keywords: draft.keywords.trim() }); setPage(1); setFilterOpen(false); }, [draft]); const clear = useCallback(() => { setDraft(initial); setApplied(initial); setPage(1); setFilterOpen(false); }, []); const changePage = (newPage) => { if (newPage < 1 || newPage > totalPages) return; setPage(newPage); window.scrollTo({ top: 0, behavior: "smooth" }); };
  return <div className="min-h-screen bg-gray-50 text-gray-900"><header className="relative overflow-hidden bg-red-950 py-20 text-center text-white"><div className="absolute inset-0 bg-cover bg-center opacity-35" style={{ backgroundImage: `url(${BASE_URL}/assets/images/events-banner-main.jpg)` }} /><div className="relative mx-auto max-w-3xl px-4"><p className="text-xs font-bold uppercase tracking-[.25em] text-red-200">Stay ahead of the industry calendar</p><h1 className="mt-3 text-4xl font-extrabold sm:text-5xl">ASSOCHAM Events</h1></div></header><section className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8"><div className="grid gap-6 lg:grid-cols-[280px_minmax(0,1fr)]"><aside className="hidden h-fit rounded-2xl border border-gray-200 bg-white p-5 shadow-sm lg:sticky lg:top-5 lg:block"><p className="text-xs font-bold uppercase tracking-wider text-gray-400">Filter by</p><h2 className="mb-4 text-lg font-bold">Events Search</h2><Filters draft={draft} setDraft={setDraft} search={search} clear={clear} eventTypes={eventTypes} subjects={subjects} /></aside><main className="space-y-5"><div className="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm"><div className="flex flex-col gap-4 border-b border-gray-100 pb-4 sm:flex-row sm:items-center sm:justify-between"><div><p className="text-xs font-bold uppercase tracking-wider text-red-700">Events Directory</p><h2 className="mt-1 text-2xl font-bold">{applied.tab === "forthcoming" ? "Forthcoming Events" : "Past Events"}</h2></div><div className="flex rounded-lg border border-gray-200 bg-gray-50 p-1"><button onClick={() => { setDraft({ ...draft, tab: "forthcoming" }); setApplied({ ...applied, tab: "forthcoming" }); setPage(1); }} className={`rounded-md px-4 py-1.5 text-sm font-medium ${applied.tab === "forthcoming" ? "bg-red-700 text-white" : "text-gray-500"}`}>Forthcoming</button><button onClick={() => { setDraft({ ...draft, tab: "past" }); setApplied({ ...applied, tab: "past" }); setPage(1); }} className={`rounded-md px-4 py-1.5 text-sm font-medium ${applied.tab === "past" ? "bg-red-700 text-white" : "text-gray-500"}`}>Past</button></div></div><div className="mt-4 flex items-center justify-between"><div><p className="text-lg font-bold">Events ({loading ? "..." : events.length})</p><p className="text-sm text-gray-500">{loading ? "Loading events..." : `Showing ${events.length ? (page - 1) * EVENTS_PER_PAGE + 1 : 0}–${Math.min(page * EVENTS_PER_PAGE, events.length)} of ${events.length} results`}</p></div><button onClick={() => setFilterOpen(true)} className="rounded-lg border border-gray-200 px-3 py-2 text-sm font-semibold lg:hidden">Filters</button></div></div>{error && <div className="rounded-xl border border-red-200 bg-red-50 p-4 text-sm text-red-700">{error}</div>}<div className="grid gap-3">{loading ? Array.from({ length: 4 }).map((_, i) => <div key={i} className="h-44 animate-pulse rounded-2xl bg-gray-200" />) : pageEvents.map((event) => <EventCard key={event.id} event={event} active={applied.tab === "forthcoming"} />)}</div>{!loading && events.length === 0 && <div className="rounded-2xl border border-dashed border-gray-300 bg-white p-10 text-center"><h3 className="font-bold">No matching events</h3><button onClick={clear} className="mt-4 rounded-lg bg-red-700 px-4 py-2 text-sm font-bold text-white">Reset filters</button></div>}{!loading && events.length > EVENTS_PER_PAGE && <Pagination page={page} totalPages={totalPages} onChange={changePage} />}</main></div></section>{filterOpen && <div className="fixed inset-0 z-50 bg-black/40 p-4 lg:hidden"><div className="ml-auto h-full max-w-sm overflow-y-auto rounded-2xl bg-white p-5"><div className="mb-5 flex items-center justify-between"><h2 className="text-lg font-bold">Events Search</h2><button onClick={() => setFilterOpen(false)} className="text-2xl">×</button></div><Filters draft={draft} setDraft={setDraft} search={search} clear={clear} eventTypes={eventTypes} subjects={subjects} /></div></div>}</div>;
}
